import { Link, Outlet } from "react-router-dom";
import { useRef } from "react";
import "./css-components/navbar.css";


function Navbar(){

    // Navbar scroll down effect
    window.addEventListener('scroll',()=>{
        document.querySelector('nav').classList.toggle('window-scroll',window.scrollY>0)

    });

    // tab toggle nav menu
    const navRef= useRef();
    const showNav=()=>{
        navRef.current.classList.toggle("nav_menu");
        
    }
   
    


    // const menu= document.querySelector(".nav__menu");
    // const menuBtn= document.querySelector("#open-menu-btn");
    // const closeBtn= document.querySelector("#close-menu-btn");

    // //open nav menu
    // menuBtn.addEventListener('click',()=>{
    //     menu.style.display ="flex";
    //     closeBtn.style.display ="inline-block";
    //     menuBtn.style.display ="none";
    // })
    // //close nav menu
    // const closeNav=()=>{
    //     menu.style.display ="none";
    //     closeBtn.style.display ="none";
    //     menuBtn.style.display ="inline-block";
    // }
    // closeBtn.addEventListener("click",closeNav)
    
    return(

        <>
        <nav>
        <div className="container nav__container">
               <Link to="/"><h1>Learners</h1></Link>
            <ul className="nav__menu" ref={navRef}>
                <li><Link to="/" className="link">Home</Link></li>
                <li><Link to="./about" className="link">About</Link></li>
                <li><Link to="./courses" className="link">Courses</Link></li>
                <li><Link to="./contact" className="link">Contact</Link></li>
            </ul>
            <button id="open-menu-btn" onClick={showNav}><i className="fa-solid fa-bars"></i></button>
            <button id="close-menu-btn" onClick={showNav}><i className="fa-solid fa-xmark"></i></button>
            <Outlet/>
            
        </div>
        </nav>
        </>
    )
}
export default Navbar;